import { useTranslation } from 'react-i18next'
import { AvailabilityBadge, PriceOrDiscountBlock } from '@/shared/components/cse'
import { formatIsoDateTimeDisplay } from '@/shared/lib/datetime'
import { formatMoneyCents } from '@/shared/lib/formatMoney'
import { createLazyThemedIcon } from '@/shared/theme/resolveThemedIcon'
import type { MatchEventListItem } from '@/features/match-event/schemas/matchEvent.schema'
import { HorizonMediaCard } from '../../../shared/components/HorizonMediaCard'

const CalendarIcon = createLazyThemedIcon('calendar')

export function HorizonMatchCard({
  event,
  priority = false,
}: {
  event: MatchEventListItem
  priority?: boolean
}) {
  const { t } = useTranslation()
  const detailTo = `/match-event/${encodeURIComponent(event.id)}`

  return (
    <HorizonMediaCard
      to={detailTo}
      title={event.title}
      subtitle={formatIsoDateTimeDisplay(event.starts_at)}
      badges={
        <>
          <AvailabilityBadge
            label={event.has_available_seats ? t('match_event.available') : t('match_event.sold_out')}
            available={event.has_available_seats}
          />
          <span className="inline-flex min-h-8 items-center rounded-[var(--brand-radius-pill)] border border-[var(--brand-border)] bg-[var(--brand-background)]/95 px-2.5 text-xs font-medium text-[var(--brand-text-secondary)] shadow-[var(--brand-shadow-1)]">
            {event.sport.name}
          </span>
        </>
      }
      price={
        event.price_subsidized_cents != null ? (
          <PriceOrDiscountBlock
            bare
            label={t('match_event.price_label')}
            value={formatMoneyCents(event.price_subsidized_cents)}
            compareAt={event.price_public_cents != null ? formatMoneyCents(event.price_public_cents) : undefined}
            helper={t('match_event.price_helper')}
          />
        ) : undefined
      }
      actionLabel={t('match_event.view')}
      actionAriaLabel={t('match_event.view_aria', { title: event.title })}
      imageUrl={event.cover_image_url}
      imageWebpUrl={event.cover_image_webp_url}
      fallbackIcon={CalendarIcon}
      priority={priority}
    />
  )
}
